import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { QUICK_TEST_STATUS } from '../quick-test-panel/QuickTestConstants';

export const NO_PREF = { '*': i18n._(t`No Preference`) };
export const CALLEE = 'callee';
export const CALLER = 'caller';
export const PHONE_ID = 'phone';

export const CALL_DURATION_OPTIONS = [10, 30, 60, 120, 300, 600, 900];
export const SCHEDULED_CALL_DURATION_OPTIONS = [10, 20, 30, 40, 50, 60];
export const JITTER_OPTIONS = [30, 50, 100, 150, 200];
export const SCHEDULED_RING_DURATION_OPTIONS = [15, 10, 20, 30, 40, 50, 60];

export const DEFAULT_JITTER = '50';
export const DEFAULT_DURATION = '10';
export const DEFAULT_RING_DURATION = '15';
export const VOIP_PULSE_TEST_TYPE = 'VoipPulse';
export const VOIP_PHONE_TEST_TYPE = 'VoipPhone';

export const CALL_VIA_PHONE_NUMBER = 'phn:';
export const CALL_VIA_EXTENSION = 'ext:';
export const CALL_VIA_SIP_USER_ID = 'uid:';

export const INITIAL_TEST_STATUS = QUICK_TEST_STATUS.INITIALIZING;
export const INITIAL_RESULT_STATUS = 'I';
export const INITIAL_PHONE_STATUS = 'N';
export const EMPTY_RESULTS_OBJECT = {
    agent: null,
    agentGuid: null,
    events: [],
    results: [],
    status: INITIAL_RESULT_STATUS,
};

export const CODECS_PCMU = 'pcmu';
export const CODECS_G726 = 'g726';
export const CODECS_GSM = 'gsm';
export const CODECS_PCMA = 'pcma';
export const CODECS_G722 = 'g722';
export const CODECS_G729 = 'g729';
export const CODECS = {
    [CODECS_PCMU]: i18n._(t`G.711U/PCMU`),
    [CODECS_G726]: i18n._(t`G.726 32K`),
    [CODECS_GSM]: i18n._(t`GSM`),
    [CODECS_PCMA]: i18n._(t`G.711A/PCMA`),
    [CODECS_G722]: i18n._(t`G.722`),
    [CODECS_G729]: i18n._(t`G.729`),
};
export const ALL_CODECS_KEY_VALUE = {
    [CODECS_PCMU]: CODECS[CODECS_PCMU],
    [CODECS_G726]: CODECS[CODECS_G726],
    [CODECS_GSM]: CODECS[CODECS_GSM],
    [CODECS_PCMA]: CODECS[CODECS_PCMA],
    [CODECS_G722]: CODECS[CODECS_G722],
    [CODECS_G729]: CODECS[CODECS_G729],
};

export const WITH_NO_PREFS_CODECS_KEY_VALUE = {
    ...NO_PREF,
    ...ALL_CODECS_KEY_VALUE,
};

export const CALL_VIA_OPTIONS = [
    { name: i18n._(t`Phone Number`), value: CALL_VIA_PHONE_NUMBER },
    { name: i18n._(t`Extension`), value: CALL_VIA_EXTENSION },
];

export const MS = ' ms';
export const PERCENT = ' %';
export const EMPTY = '--';
export const PHONE = 'phone';
export const METRIC_LUT = {
    mos: 'lqmos_curr',
    latency: 'rtt_curr',
    loss: 'rx_pct_loss_delta',
    jitter: 'rx_jitter_curr',
};
export const AVG_METRIC_LUT = {
    mos: 'lqmos_avg',
    latency: 'rtt_avg',
    loss: 'rx_pct_loss',
    jitter: 'rx_jitter_avg',
    securityMode: 'security_mode',
};
export const METRIC_UNITS = {
    lqmos_avg: {
        places: 2,
    },
    rtt_avg: {
        metric: MS,
        places: 2,
    },
    rx_pct_loss: {
        metric: PERCENT,
        places: 2,
    },
    rx_jitter_avg: {
        metric: MS,
        places: 2,
    },
    security_mode: {
        places: 2,
    },
};
export const COLORS = {
    green: '#70C377',
    yellow: '#FFDC75',
    red: '#EB7861',
};

// Used for the overall test status
export const TEST_STATUS_LUT = {};
TEST_STATUS_LUT[QUICK_TEST_STATUS.INITIALIZING] = QUICK_TEST_STATUS.INITIALIZING;
TEST_STATUS_LUT[QUICK_TEST_STATUS.SETTING_UP] = QUICK_TEST_STATUS.SETTING_UP;
TEST_STATUS_LUT[QUICK_TEST_STATUS.RUNNING] = QUICK_TEST_STATUS.RUNNING;
TEST_STATUS_LUT[QUICK_TEST_STATUS.TEARING_DOWN] = QUICK_TEST_STATUS.TEARING_DOWN;
TEST_STATUS_LUT[QUICK_TEST_STATUS.COMPLETE] = QUICK_TEST_STATUS.COMPLETE;
TEST_STATUS_LUT[QUICK_TEST_STATUS.ERROR] = QUICK_TEST_STATUS.ERROR;
TEST_STATUS_LUT[QUICK_TEST_STATUS.CANCELED] = QUICK_TEST_STATUS.CANCELED;

// Used for the Agent Status
export const STATUS_LUT = {
    I: 'Initializing',
    S: 'Setting Up',
    R: 'Running',
    T: 'Tearing Down',
    C: 'Complete',
    E: 'Error',
    X: 'Canceled',
};

// More Agent Statuses
export const STATUS_AGENT = {
    both: {
        D: 'Account Unregistered',
        U: 'Call Unanswered',
        M: 'Call Terminated',
        Z: 'Register Wave Failure',
        L: 'Place Call Failure',
        B: 'Expired',
        V: 'Unhandled Call State',
        G: 'Call Error',
        O: 'Call Beginning',
        T: 'Duration Reached',
        H: 'Hangup Call',
        F: 'Call Ending',
        AC: 'No Media Present',
        AA: 'Not an nPoint',
        AB: 'Wrong nPoint',
    },
    caller: {
        Q: 'Waiting to Call (Queued)',
        W: 'Waiting to Call',
        P: 'Placing Call',
        A: 'Call Accepted',
        J: 'Callee DNS Resolve Error',
        K: 'Invalid Callee URI',
        Y: 'Invalid Phone Number',
    },
    callee: {
        W: 'Waiting for Call',
        A: 'Call Accepted',
    },
};
